import React, { useContext } from 'react';
import { VideoTeaserEntry } from '../helper/interfaces';
import { TeaserData } from './teaser';
import { CmpIdentifier } from '../helper/enums';
import { ConsentContext } from '../provider/ConsentContextProvider';

export default function Teaser23Grad(data: TeaserData) {
  const teaser = data.teaser;
  const providerId = (teaser as VideoTeaserEntry).providerId;

  const { getProviderId } = useContext(ConsentContext);
  const cmpVendorId = getProviderId(CmpIdentifier.TwentyThreeDegrees);

  return (
    <>
    {cmpVendorId &&
      <>
        <style>{`
          .responsive23-${providerId} {
            width: 100%;
            padding-top: 100%;
          }
          @media (max-width: 800px) {
            .responsive23-${providerId} {
              padding-top: 76.92%;
            }
          }
          @media (max-width: 600px) {
            .responsive23-${providerId} {
              padding-top: 100%;
            }
          }
          @media (max-width: 480px) {
            .responsive23-${providerId} {
              padding-top: 111.11%;
            }
          }
          @media (max-width: 360px) {
            .responsive23-${providerId} {
              padding-top: 142.86%;
            }
          }
        `}</style>
        <div className={`responsive23-${providerId}`} id={`container23-${providerId}`} style={{ position: 'relative' }}>
          <iframe
            src="about:blank"
            allow="fullscreen"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
            className="cmplazyload"
            data-cmp-vendor={cmpVendorId}
            data-cmp-src={`https://app.23degrees.io/embed/${providerId}`}
            data-cmp-ab="1"
          ></iframe>
        </div>
        <script
          async
          className="cmplazyload"
          data-cmp-vendor={cmpVendorId}
          data-cmp-src={`https://app.23degrees.io/services/public/embed-code/${providerId}`}
          id={`23degrees-script-${providerId}`}
          type="text/plain" 
          data-cmp-ab="1"
        />
      </>
    }
    </>
  );
}